/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';
import { chartDataJson } from './SampleCSVData';

export const page: {
  root: Item<'Page'>;
  localDataStore: Item<'LocalDataStore'>;
  flexItem2: Item<'FlexItem'>;
  chartjs: Item<'Chartjs'>;
  flexItem1: Item<'FlexItem'>;
  flexItem: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  emptySpacer: Item<'EmptySpacer'>;
  emptySpacer1: Item<'EmptySpacer'>;
  chartJsTooltip: Item<'ChartJSTooltip'>;
  box: Item<'Box'>;
  typography: Item<'Typography'>;
  typography1: Item<'Typography'>;
  divider: Item<'Divider'>;
  box1: Item<'Box'>;
  typography2: Item<'Typography'>;
  box2: Item<'Box'>;
  divider1: Item<'Divider'>;
} = {
  box: {
    children: ['box1', 'divider1', 'box2'],
    itemId: 'box',
    parent: 'chartJsTooltip',
    props: {
      bgcolor: {
        type: 'text',
        value: 'background.paper',
      },
      border: {
        all: {
          style: 'solid',
          width: 1,
        },
      },
      borderRadius: '8px',
      boxShadow: '3',
      flexDirection: 'column',
      gap: '8px',
      justifyContent: 'flex-start',
    },
    type: 'Box',
  },
  box1: {
    children: ['typography2'],
    itemId: 'box1',
    parent: 'box',
    props: {
      flexDirection: 'column',
      padding: {
        bottom: 0,
        left: 0,
        right: 0,
        top: 8,
      },
    },
    type: 'Box',
  },
  box2: {
    children: ['typography', 'divider', 'typography1'],
    itemId: 'box2',
    parent: 'box',
    props: {
      gap: '8px',
      padding: {
        bottom: 8,
        left: 16,
        right: 16,
        top: 0,
      },
    },
    type: 'Box',
  },
  chartJsTooltip: {
    children: ['box'],
    itemId: 'chartJsTooltip',
    parent: 'chartjs',
    props: {
      open: true,
      toolTipOnTop: true,
    },
    type: 'ChartJSTooltip',
  },
  chartjs: {
    children: ['chartJsTooltip'],
    itemId: 'chartjs',
    parent: 'flexItem1',
    props: {
      chartType: 'line',
      dsalias: 'test',
      functionType: 'Avg',
      gridLines: 'y',
      labelAttribute: 'name',
      legendPosition: 'left',
      valueAttribute: 'someNumber',
    },
    type: 'Chartjs',
  },
  divider: {
    children: [],
    itemId: 'divider',
    parent: 'box2',
    props: {
      dividerHeight: '24px',
      orientation: 'vertical',
    },
    type: 'Divider',
  },
  divider1: {
    children: [],
    itemId: 'divider1',
    parent: 'box',
    props: {
      dividerHeight: '',
    },
    type: 'Divider',
  },
  emptySpacer: {
    children: [],
    itemId: 'emptySpacer',
    parent: 'flexItem2',
    props: {},
    type: 'EmptySpacer',
  },
  emptySpacer1: {
    children: [],
    itemId: 'emptySpacer1',
    parent: 'flexItem',
    props: {},
    type: 'EmptySpacer',
  },
  flexItem: {
    children: ['emptySpacer1'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexItem1: {
    children: ['chartjs'],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {
      backgroundColor: 'paper',
      max: 420,
      min: 420,
      padding: {
        all: 16,
      },
      sizeType: 'minmax',
    },
    type: 'FlexItem',
  },
  flexItem2: {
    children: ['emptySpacer'],
    itemId: 'flexItem2',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem2', 'flexItem1', 'flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {
      renderAs: 'columns',
    },
    type: 'FlexPanel',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'test',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData: chartDataJson,
    },
    type: 'LocalDataStore',
  },
  root: {
    children: ['localDataStore', 'flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  typography: {
    children: [],
    itemId: 'typography',
    parent: 'box2',
    props: {
      color: {
        type: 'text',
        value: 'text.secondary',
      },
      text: {
        type: 'expression',
        value: "$.$chartTooltipData.data[0]?.label ?? 'No Label...'",
      },
    },
    type: 'Typography',
  },
  typography1: {
    children: [],
    itemId: 'typography1',
    parent: 'box2',
    props: {
      text: {
        type: 'expression',
        // eslint-disable-next-line no-template-curly-in-string
        value: '`${$.$chartTooltipData.data[0]?.value ?? 0} units`',
      },
    },
    type: 'Typography',
  },
  typography2: {
    children: [],
    itemId: 'typography2',
    parent: 'box1',
    props: {
      noWrap: true,
      text: {
        type: 'text',
        value: 'Some Title...',
      },
    },
    type: 'Typography',
  },
};
